var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('hm-col',{attrs:{"id":_vm.$attrs['id'],"cols":"12"}},[_c('blockquote',{class:['blockquote', ("blockquote--" + _vm.icon)]},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.text)}}),_vm._v(" "),_c('cite',[_vm._v(_vm._s(_vm.env('WHITE_LABEL_NAME') || 'Hotelmeister'))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-688f91d3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/lib/util/Hint.vue
// module id = yPbN
// module chunks = 0